export default "__VITE_ASSET__CAkgdY4A__"